"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var resolveQueryStringToRecipient_1 = require("../actions/resolveQueryStringToRecipient");
function searchDirectory(recipientWell) {
    resolveQueryStringToRecipient_1.default(recipientWell, false /* shouldDirectlyResolve */, true /* searchDirectory */);
}
exports.default = searchDirectory;
//# sourceMappingURL=searchDirectory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/utils/searchDirectory.js
// module id = 3080
// module chunks = 2 3